import dayjs from 'utils/customDayJS';

export const browserTimeZone = dayjs.tz.guess();
export const timeFormat1 = 'hh:mm a z';
